import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { dateToFrenchFormat } from '@europrocurement/l2d-utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TextIcon } from '../TextIcon';

export type ModificationDateProps = {
    date?: Date;
    isCreationDate?: boolean;
    displayIcon?: boolean;
    sxProps?: SxProps;
};

export const ModificationDate: React.FunctionComponent<ModificationDateProps> = function ({
    date,
    isCreationDate = false,
    displayIcon = true,
    sxProps,
}) {
    const CALENDAR_ICON: IconProp = ['fasl', 'calendar']; // Mockup icon is far / Icon display issue with far prefix
    const sx = {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        width: '100%',
        ...sxProps,
    };
    const displayDate = (): string | null => {
        if (!date) {
            return null;
        }
        const dateInformation = dateToFrenchFormat(date);
        const prefix = isCreationDate ? 'Créé' : 'Mis à jour';
        return `${prefix} le ${dateInformation}`;
    };
    return (
        <Box
            data-testid="ModificationDate-wrapper"
            sx={sx}
        >
            {displayIcon ? (
                <TextIcon
                    icon={{ props: { icon: CALENDAR_ICON } }}
                    gap="6px"
                >
                    <Typography data-testid="ModificationDate-display">{displayDate()}</Typography>
                </TextIcon>
            ) : (
                <Typography data-testid="ModificationDate-display">{displayDate()}</Typography>
            )}
        </Box>
    );
};
